import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { FooterComponent } from './footer/footer.component';

@NgModule({
	declarations: [FooterComponent],
	exports: [FooterComponent],
	imports: [CommonModule, NgbModule, TranslateModule]
})
export class FooterModule {}
